// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"47717fb6","707":"ca57f51f","949":"014c48c6"}[chunkId] + ".chunk.css";
};